/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Rola, w jakiej uzytkownik oglada profil pracownika. Administrator certyfikacji nie wystepuje na tej liscie — ta rola nie daje wejscia na profil. 
 * @export
 * @enum {string}
 */

export const EmployeeProfileRoleDto = {
    Admin: 'ADMIN',
    AdminSuccession: 'ADMIN_SUCCESSION',
    AdminDevelopment: 'ADMIN_DEVELOPMENT',
    Hrbp: 'HRBP',
    HqHrbp: 'HQ_HRBP',
    Owner: 'OWNER',
    P1: 'P1',
    P2: 'P2',
    NoAccess: 'NO_ACCESS',
    ForceAccess: 'FORCE_ACCESS'
} as const;

export type EmployeeProfileRoleDto = typeof EmployeeProfileRoleDto[keyof typeof EmployeeProfileRoleDto];



